import { action } from 'easy-peasy';
import { MESSAGE_TYPES } from '../utils';

const showMessage = {
	showingMessage: false,
	showMessageData: {},
	showMessage: action((state, payload) => {
		state.showingMessage = true;
		const { text, type = MESSAGE_TYPES.SUCCESS } = payload;
		state.showMessageData = {
			text,
			type,
		};
	}),
	hideMessage: action((state) => {
		state.showingMessage = false;
		state.showMessageData = {};
	}),
};

export default showMessage;
